import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import {UtilsService} from '../common/services/utils.service';
import * as $ from 'jquery';
declare var hide_trade_entity_box: Function;
declare var show_okshan_alert: Function;

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {   
   isRequestInprocess:boolean=false;   

   editProfileDetailStatus:boolean=false;
   profileDetailFormGroup;
   firstName;
   lastName;
   contactPersonName;
   contactPersonNo;
   companyName;
   isProfileDetailSubmitted:boolean=false;
   profileDetailSaveBtnLabel="Save";
   profileDetail;
   kycStatus:string="KYC Documents";
   kycBit:number=0;
   profileApprovalStatus:number=0;

  editKycDetailStatus:boolean=false; 
  kycDetailFromGroup;
  registerationTradeEntity;
  registerationIndName;
  registerationIndPhoneNo;
  registerationIndAlternateNo;
  registerationIndEmail;
  registerationIndPan;
  registerationIndGstno;
  registerationIndPanFile="";
  registerationIndAadhaarFile="";
  registerationIndPassportFile="";
  registerationIndDLFile="";
  registerationIndVoterFile="";
  registerationIndPhotoFile="";
  registerationIndBusinessProofFile="";
  registerationProTradeName;
  registerationProNo;
  registerationProName;
  registerationProPhoneNo;
  registerationProAlternateNo;
  registerationProEmail;
  registerationProPan;
  registerationProGstNo;
  registerationProPanFile="";
  registerationProAadhaarFile="";
  registerationProPassportFile="";
  registerationProDLFile="";
  registerationProVoterFile="";
  registerationProPhotoFile="";
  registerationProBusinessProofFile="";
  registerationParName;
  registerationParPartnerName;
  registerationParPhoneNo;
  registerationParAlternateNo;
  registerationParPan;
  registerationParEmail;
  registerationParPanFile="";
  registerationParGstFile="";
  registerationParBusinessProofFile="";
  registerationParPartnershipProofFile="";
  registerationParPhotoFile="";
  registerationParPan2File="";
  registerationParAddressProofFile="";
  registerationParAuthorityLetterFile="";
  registerationLimName;
  registerationLimPartnerName;
  registerationLimPhoneNo;
  registerationLimAlternateNo;
  registerationLimRocNo;
  registerationLimRocDate;
  registerationLimPan;
  registerationLimGstno;
  registerationLimPanFile="";
  registerationLimGstFile="";
  registerationLimCertificateFile="";
  registerationLimBusinessProofFile="";
  registerationLimPartnershipProofFile="";
  registerationLimPhotoFile="";
  registerationLimPan2File="";
  registerationLimAddressProofFile="";
  registerationLimAuthorityFile="";
  registerationPriName;
  registerationPriPartnerName;
  registerationPriPhoneNo;
  registerationPriAlternateNo;
  registerationPriRocNo;
  registerationPriRocDate;
  registerationPriPanNo;
  registerationPriGstNo;
  registerationPriPanFile="";
  registerationPriGstFile="";
  registerationPriCertificateFile="";
  registerationPriBusinessProofFile="";
  registerationPriArticlesFile="";
  registerationPriPhotoFile="";
  registerationPripan2File="";
  registerationPriAddressProofFile="";
  registerationPriResolutionFile="";
  registerationCancelChequeFile="";

  registerationIndPanUploadedFile="";
  registerationIndAadhaarUploadedFile="";
  registerationIndPassportUploadedFile="";
  registerationIndDLUploadedFile="";
  registerationIndVoterUploadedFile="";
  registerationIndPhotoUploadedFile="";
  registerationIndBusinessProofUploadedFile="";

registerationProPanUploadedFile="";
  registerationProAadhaarUploadedFile="";
  registerationProPassportUploadedFile="";
  registerationProDLUploadedFile="";
  registerationProVoterUploadedFile="";
  registerationProPhotoUploadedFile="";
  registerationProBusinessProofUploadedFile="";

registerationParPanUploadedFile="";
  registerationParGstUploadedFile="";
  registerationParBusinessProofUploadedFile="";
  registerationParPartnershipProofUploadedFile="";
  registerationParPhotoUploadedFile="";
  registerationParPan2UploadedFile="";
  registerationParAddressProofUploadedFile="";
  registerationParAuthorityLetterUploadedFile="";

registerationLimPanUploadedFile="";
  registerationLimGstUploadedFile="";
  registerationLimCertificateUploadedFile="";
  registerationLimBusinessProofUploadedFile="";
  registerationLimPartnershipProofUploadedFile="";
  registerationLimPhotoUploadedFile="";
  registerationLimPan2UploadedFile="";
  registerationLimAddressProofUploadedFile="";
  registerationLimAuthorityUploadedFile="";

registerationPriPanUploadedFile="";
  registerationPriGstUploadedFile="";
  registerationPriCertificateUploadedFile="";
  registerationPriBusinessProofUploadedFile="";
  registerationPriArticlesUploadedFile="";
  registerationPriPhotoUploadedFile="";
  registerationPripan2UploadedFile="";
  registerationPriAddressProofUploadedFile="";
  registerationPriResolutionUploadedFile="";

  

  kycDetailSaveBtnLabel="Save"
  @ViewChild('entityTypeSelect') entityTypeSelect: ElementRef;

  changePasswordFormGroup;
  oldPassword;
  newPassword;
  confirmPassword;
  isPasswordSubmitted=false;
  chnagePasswordBtnLbl="Save";
  changePasswordMsg="";

  creditCardFormGroup;
  creditCardName;
  creditCardNo;
  creditCardMonth;
  creditCardYear;
  isCreditCardSubmited=false;
  creditCardBtnLbl="Save";
  creditCardMsg="";

  debitCardFormGroup;
  debitCardName;
  debitCardNo;
  debitCardMonth;
  debitCardYear;
  isDebitCardSubmited=false;
  debitCardBtnLbl="Save";
  debitCardMsg="";

  bankDetailFormGroup;
  bankName;
  bankIfscCode;
  bankAddress;
  bankAccountNo;
  cancelledCheque;
  cancelledChequeFile;
  isBankDetailSubmited=false;
  bankDetailBtnLbl="Save";
  bankDetailMsg="";

  addressList;
  addressDetailFormGroup;
  addressDetail;
  addressState;
  addressCity;
  addressPincode;
  isaAddressDetailSubmited=false;
  addressDetailBtnLbl="Save";
  addressDetailMsg="";
  stateList;
  cityList=[
    {"id":0,name:"Select state first"}
  ];
  allStateList;
  allcityList;

  chnagePasswordSendOtpBtnLbl="Send";

  
  constructor(private httpserviceService:HttpserviceService,private sessionsService:SessionsService,private router:Router,private _constant: ConstantsService,private utilsService:UtilsService) { }

  ngOnInit(): void {
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
  window.scrollTo(0, 0);    

    
this.profileDetailFormGroup=new FormGroup(
      {
        firstName: new FormControl("",[Validators.required]),
        lastName: new FormControl(""),
        contactPersonName: new FormControl(""),
        contactPersonNo: new FormControl("",[Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
        companyName: new FormControl(""),
      }
    );

  this.kycDetailFromGroup=new FormGroup(
      {
        registerationTradeEntity: new FormControl('0',Validators.min(1)),
          registerationIndName: new FormControl('',[Validators.required]),
          registerationIndPhoneNo: new FormControl('',[Validators.required]),
          registerationIndAlternateNo: new FormControl(''),
          registerationIndEmail: new FormControl('',[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
          registerationIndPan: new FormControl(''),
          registerationIndGstno: new FormControl(''),
          registerationProTradeName: new FormControl('',[Validators.required]),
          registerationProNo: new FormControl('',[Validators.required]),
          registerationProName: new FormControl('',[Validators.required]),
          registerationProPhoneNo: new FormControl('',[Validators.required]),
          registerationProAlternateNo: new FormControl(''),
          registerationProEmail: new FormControl('',[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
          registerationProPan: new FormControl(''),
          registerationProGstNo: new FormControl(''),
          registerationParName: new FormControl('',[Validators.required]),
          registerationParPartnerName: new FormControl('',[Validators.required]),
          registerationParPhoneNo: new FormControl('',[Validators.required]),
          registerationParAlternateNo: new FormControl(''),
          registerationParPan: new FormControl(''),
          registerationParEmail: new FormControl(''),
          registerationLimName: new FormControl('',[Validators.required]),
          registerationLimPartnerName: new FormControl('',[Validators.required]),
          registerationLimPhoneNo: new FormControl('',[Validators.required]),
          registerationLimAlternateNo: new FormControl(''),
          registerationLimRocNo: new FormControl(''),
          registerationLimRocDate: new FormControl(''),
          registerationLimPan: new FormControl(''),
          registerationLimGstno: new FormControl(''),
          registerationPriName: new FormControl('',[Validators.required]),
          registerationPriPartnerName: new FormControl('',[Validators.required]),
          registerationPriPhoneNo: new FormControl('',[Validators.required]),
          registerationPriAlternateNo: new FormControl(''),
          registerationPriRocNo: new FormControl(''),
          registerationPriRocDate: new FormControl(''),
          registerationPriPanNo: new FormControl(''),
          registerationPriGstNo: new FormControl(''),
      }
    );  


    this.changePasswordFormGroup=new FormGroup(
      {
        oldPassword: new FormControl("",[Validators.required]),
        newPassword: new FormControl("",[Validators.required,Validators.minLength(8)]),
        confirmPassword: new FormControl("",[Validators.required,Validators.minLength(8)]),        
      }
    );

    this.creditCardFormGroup=new FormGroup(
      {
        creditCardName: new FormControl("",[Validators.required]),
        creditCardNo: new FormControl("",[Validators.required]),
        creditCardMonth: new FormControl("",[Validators.required]),
        creditCardYear: new FormControl("",[Validators.required]),        
      }
    );
    this.debitCardFormGroup=new FormGroup(
      {
        debitCardName: new FormControl("",[Validators.required]),
        debitCardNo: new FormControl("",[Validators.required]),
        debitCardMonth: new FormControl("",[Validators.required]),
        debitCardYear: new FormControl("",[Validators.required]),        
      }
    );
    this.bankDetailFormGroup=new FormGroup(
      {
        bankName: new FormControl("",[Validators.required]),
        bankIfscCode: new FormControl("",[Validators.required]),
        bankAddress: new FormControl("",[Validators.required]),
        bankAccountNo: new FormControl("",[Validators.required]),        
      }
    );
    this.addressDetailFormGroup=new FormGroup(
      {
        addressDetail: new FormControl("",[Validators.required]),
        addressState: new FormControl("0",[Validators.required,Validators.min(1)]),
        addressCity: new FormControl("0",[Validators.required,Validators.min(1)]),
        addressPincode: new FormControl("",[Validators.required,Validators.maxLength(6)]),        
      }
    );


    setTimeout(() => {
      hide_trade_entity_box();
    }, 200);

    this.stateList=this.sessionsService.getSession("state_list");  
    this.allStateList=this.sessionsService.getSession("all_state");
    this.allcityList=this.sessionsService.getSession("all_city");
    this.proceedGetProfileDetail();
  }

  /** editProfileDetail function used to edit profile detail */
  editProfileDetail()
  {
    this.editProfileDetailStatus=true;
  }

  /** cancelEditProfileDetail function used to cancel edit profile detail */
  cancelEditProfileDetail()
  {
    this.editProfileDetailStatus=false;
    this.profileDetailSaveBtnLabel="Save";
    this.isRequestInprocess=false;
  }

  /** proceedProfileDeatailSave function used to proceed profile detail save */
  proceedProfileDeatailSave(data)
  {
    this.isProfileDetailSubmitted=true;
    if(this.profileDetailFormGroup.valid)
    {
     this.isRequestInprocess=true;
     this.profileDetailSaveBtnLabel="Saving...";
     let result =this.httpserviceService.profileDetailUpdateRequest(data.firstName,data.lastName,data.contactPersonName,data.contactPersonNo,data.companyName).
     pipe(retry(0)).
     subscribe((data)=>this.profileDetailUpdateResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.profileDetailSaveBtnLabel="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
    }
  }  

 /** profileDetailUpdateResponse function used to handle response */
  profileDetailUpdateResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {      
       this.cancelEditProfileDetail();
     }
     else
     {
     this.profileDetailSaveBtnLabel="Save";  
     show_okshan_alert(response.reason);
     this.isRequestInprocess=false;    
     } 
  }

  /** proceedGetProfileDetail function used to proceed get profile detail */
  proceedGetProfileDetail()
  {
    console.log('profile details as per required for verification');
    console.log(this.sessionsService.getSession('email_id'));
    console.log(this.sessionsService.getSession('password'));
    let result =this.httpserviceService.getProfileDetailRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getProfileDetailResponse(data),
     err => {
       this.isRequestInprocess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }  

 /** getProfileDetailResponse function used to handle response */
  getProfileDetailResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {        
  this.proceedKycStatusRequest();     
  this.registerationIndPanFile="";
  this.registerationIndAadhaarFile="";
  this.registerationIndPassportFile="";
  this.registerationIndDLFile="";
  this.registerationIndVoterFile="";
  this.registerationIndPhotoFile="";
  this.registerationIndBusinessProofFile="";
  this.registerationProPanFile="";
  this.registerationProAadhaarFile="";
  this.registerationProPassportFile="";
  this.registerationProDLFile="";
  this.registerationProVoterFile="";
  this.registerationProPhotoFile="";
  this.registerationProBusinessProofFile="";
  this.registerationParPanFile="";
  this.registerationParGstFile="";
  this.registerationParBusinessProofFile="";
  this.registerationParPartnershipProofFile="";
  this.registerationParPhotoFile="";
  this.registerationParPan2File="";
  this.registerationParAddressProofFile="";
  this.registerationParAuthorityLetterFile="";
  this.registerationLimPanFile="";
  this.registerationLimGstFile="";
  this.registerationLimCertificateFile="";
  this.registerationLimBusinessProofFile="";
  this.registerationLimPartnershipProofFile="";
  this.registerationLimPhotoFile="";
  this.registerationLimPan2File="";
  this.registerationLimAddressProofFile="";
  this.registerationLimAuthorityFile="";
  this.registerationPriCertificateFile="";
  this.registerationPriBusinessProofFile="";
  this.registerationPriArticlesFile="";
  this.registerationPriPhotoFile="";
  this.registerationPripan2File="";
  this.registerationPriAddressProofFile="";
  this.registerationPriResolutionFile="";
       //this.getAddressList();  
       if(response.details.length>0)
       {   
       this.profileDetail=response.details[0];
       if(this.profileDetail)
       {
         this.profileApprovalStatus=this.profileDetail.approval_status;
         if(this.profileDetail.mobile_no.slice(0,1)=='+'){
            this.profileDetail.mobile_no = this.profileDetail.mobile_no.substring(3)
         } 
         if(this.profileDetail.contact_person_number.slice(0,1)=='+'){
            this.profileDetail.contact_person_number = this.profileDetail.contact_person_number.substring(3)
         } 
         if(this.profileDetail.field1==null)
         {
           this.profileDetail.field1="";
         }
         if(this.profileDetail.field2==null)
         {
           this.profileDetail.field2="";
         }
         if(this.profileDetail.field3==null)
         {
           this.profileDetail.field3="";
         }
         if(this.profileDetail.field4==null)
         {
           this.profileDetail.field4="";
         }
         if(this.profileDetail.field5==null)
         {
           this.profileDetail.field5="";
         }
         if(this.profileDetail.field6==null)
         {
           this.profileDetail.field6="";
         }
         if(this.profileDetail.field7==null)
         {
           this.profileDetail.field7="";
         }
         if(this.profileDetail.field8==null)
         {
           this.profileDetail.field8="";
         }
         if(this.profileDetail.kyc_doc_1==null)
         {
           this.profileDetail.kyc_doc_1="";
         }
         if(this.profileDetail.kyc_doc_2==null)
         {
           this.profileDetail.kyc_doc_2="";
         }
         if(this.profileDetail.kyc_doc_3==null)
         {
           this.profileDetail.kyc_doc_3="";
         }
         if(this.profileDetail.kyc_doc_4==null)
         {
           this.profileDetail.kyc_doc_4="";
         }
         if(this.profileDetail.kyc_doc_5==null)
         {
           this.profileDetail.kyc_doc_5="";
         }
         if(this.profileDetail.kyc_doc_6==null)
         {
           this.profileDetail.kyc_doc_6="";
         }
         if(this.profileDetail.kyc_doc_7==null)
         {
           this.profileDetail.kyc_doc_7="";
         }
         if(this.profileDetail.kyc_doc_8==null)
         {
           this.profileDetail.kyc_doc_8="";
         }
         if(this.profileDetail.kyc_doc_9==null)
         {
           this.profileDetail.kyc_doc_9="";
         }
         this.profileDetail.credit_card_month="";
         this.profileDetail.credit_card_year="";
         if(this.profileDetail.credit_card_expiration!=null)
         {
           if(this.profileDetail.credit_card_expiration!="")
           {
             let monthYearArray=this.profileDetail.credit_card_expiration.split("-");
             if(monthYearArray.length>0)
             {
               this.profileDetail.credit_card_month=monthYearArray[0];
               this.profileDetail.credit_card_year=monthYearArray[1];
             }
           }
         }
         this.profileDetail.debit_card_month="";
         this.profileDetail.debit_card_year="";
         if(this.profileDetail.expiration!=null)
         {
           if(this.profileDetail.expiration!="")
           {
             let monthYearArray=this.profileDetail.expiration.split("-");
             if(monthYearArray.length>0)
             {
               this.profileDetail.debit_card_month=monthYearArray[0];
               this.profileDetail.debit_card_year=monthYearArray[1];
             }
           }
         }
        
         this.cancelledCheque=this.profileDetail.cancelled_cheque;
        if(this.profileDetail.bank_name==null)
        {
          this.profileDetail.bank_name="";
        }
        if(this.profileDetail.ifsc_code==null)
        {
          this.profileDetail.ifsc_code="";
        }
        if(this.profileDetail.bank_address==null)
        {
          this.profileDetail.bank_address="";
        }
        if(this.profileDetail.bank_account_number==null)
        {
          this.profileDetail.bank_account_number="";
        }
        if(this.profileDetail.cancelled_cheque==null)
        {
          this.cancelledCheque="";
        }         

         this.profileDetailFormGroup.get('firstName').setValue(this.profileDetail.first_name);
         this.profileDetailFormGroup.get('lastName').setValue(this.profileDetail.last_name); 
         this.profileDetailFormGroup.get('contactPersonName').setValue(this.profileDetail.contact_person_name);
         this.profileDetailFormGroup.get('contactPersonNo').setValue(this.profileDetail.contact_person_number);
         this.profileDetailFormGroup.get('companyName').setValue(this.profileDetail.company_name);
         //this.profileDetail.trade_entity=5;
         this.kycDetailFromGroup.get('registerationTradeEntity').setValue(this.profileDetail.trade_entity); 
         //this.entityTypeSelect.nativeElement.click();
         if(this.profileDetail.trade_entity=="1" || this.profileDetail.trade_entity==1)
         {
         this.kycDetailFromGroup.get('registerationIndName').setValue(this.profileDetail.field1);
         this.kycDetailFromGroup.get('registerationIndPhoneNo').setValue(this.profileDetail.field2);
         this.kycDetailFromGroup.get('registerationIndAlternateNo').setValue(this.profileDetail.field3);  
         this.kycDetailFromGroup.get('registerationIndEmail').setValue(this.profileDetail.field4);
         this.kycDetailFromGroup.get('registerationIndPan').setValue(this.profileDetail.field5);
         this.kycDetailFromGroup.get('registerationIndGstno').setValue(this.profileDetail.field6); 
         this.registerationIndPanUploadedFile=this.profileDetail.kyc_doc_1;
         this.registerationIndAadhaarUploadedFile=this.profileDetail.kyc_doc_2;
         this.registerationIndPassportUploadedFile=this.profileDetail.kyc_doc_3;
         this.registerationIndDLUploadedFile=this.profileDetail.kyc_doc_4;
         this.registerationIndVoterUploadedFile=this.profileDetail.kyc_doc_5;
         this.registerationIndPhotoUploadedFile=this.profileDetail.kyc_doc_6;
         this.registerationIndBusinessProofUploadedFile=this.profileDetail.kyc_doc_7;
         }
         if(this.profileDetail.trade_entity=="2" || this.profileDetail.trade_entity==2)
         {
         this.kycDetailFromGroup.get('registerationProTradeName').setValue(this.profileDetail.field1);
         this.kycDetailFromGroup.get('registerationProNo').setValue(this.profileDetail.field2);
         this.kycDetailFromGroup.get('registerationProName').setValue(this.profileDetail.field3); 
         this.kycDetailFromGroup.get('registerationProPhoneNo').setValue(this.profileDetail.field4);
         this.kycDetailFromGroup.get('registerationProAlternateNo').setValue(this.profileDetail.field5);
         this.kycDetailFromGroup.get('registerationProEmail').setValue(this.profileDetail.field6);
         this.kycDetailFromGroup.get('registerationProPan').setValue(this.profileDetail.field7);
         this.kycDetailFromGroup.get('registerationProGstNo').setValue(this.profileDetail.field8);
         this.registerationProPanUploadedFile=this.profileDetail.kyc_doc_1;
         this.registerationProAadhaarUploadedFile=this.profileDetail.kyc_doc_2;
         this.registerationProPassportUploadedFile=this.profileDetail.kyc_doc_3;
         this.registerationProDLUploadedFile=this.profileDetail.kyc_doc_4;
         this.registerationProVoterUploadedFile=this.profileDetail.kyc_doc_5;
         this.registerationProPhotoUploadedFile=this.profileDetail.kyc_doc_6;
         this.registerationProBusinessProofUploadedFile=this.profileDetail.kyc_doc_7;         
         }
         if(this.profileDetail.trade_entity=="3" || this.profileDetail.trade_entity==3)
         {
         this.kycDetailFromGroup.get('registerationParName').setValue(this.profileDetail.field1);
         this.kycDetailFromGroup.get('registerationParPartnerName').setValue(this.profileDetail.field2);
         this.kycDetailFromGroup.get('registerationParPhoneNo').setValue(this.profileDetail.field3);  
         this.kycDetailFromGroup.get('registerationParAlternateNo').setValue(this.profileDetail.field4);
         this.kycDetailFromGroup.get('registerationParPan').setValue(this.profileDetail.field5);
         this.kycDetailFromGroup.get('registerationParEmail').setValue(this.profileDetail.field6);
         this.registerationParPanUploadedFile=this.profileDetail.kyc_doc_1;
         this.registerationParGstUploadedFile=this.profileDetail.kyc_doc_2;
         this.registerationParBusinessProofUploadedFile=this.profileDetail.kyc_doc_3;
         this.registerationParPartnershipProofUploadedFile=this.profileDetail.kyc_doc_4;
         this.registerationParPhotoUploadedFile=this.profileDetail.kyc_doc_5;
         this.registerationParPan2UploadedFile=this.profileDetail.kyc_doc_6;
         this.registerationParAddressProofUploadedFile=this.profileDetail.kyc_doc_7; 
         this.registerationParAuthorityLetterUploadedFile=this.profileDetail.kyc_doc_8;      
         } 
         if(this.profileDetail.trade_entity=="4" || this.profileDetail.trade_entity==4)
         {
         this.kycDetailFromGroup.get('registerationLimName').setValue(this.profileDetail.field1);
         this.kycDetailFromGroup.get('registerationLimPartnerName').setValue(this.profileDetail.field2);
         this.kycDetailFromGroup.get('registerationLimPhoneNo').setValue(this.profileDetail.field3);  
         this.kycDetailFromGroup.get('registerationLimAlternateNo').setValue(this.profileDetail.field4);
         this.kycDetailFromGroup.get('registerationLimRocNo').setValue(this.profileDetail.field5);
         this.kycDetailFromGroup.get('registerationLimRocDate').setValue(this.profileDetail.field6);
         this.kycDetailFromGroup.get('registerationLimPan').setValue(this.profileDetail.field7);
         this.kycDetailFromGroup.get('registerationLimGstno').setValue(this.profileDetail.field8);
         this.registerationLimPanUploadedFile=this.profileDetail.kyc_doc_1;
         this.registerationLimGstUploadedFile=this.profileDetail.kyc_doc_2;
         this.registerationLimCertificateUploadedFile=this.profileDetail.kyc_doc_3;
         this.registerationLimBusinessProofUploadedFile=this.profileDetail.kyc_doc_4;
         this.registerationLimPartnershipProofUploadedFile=this.profileDetail.kyc_doc_5;
         this.registerationLimPhotoUploadedFile=this.profileDetail.kyc_doc_6;
         this.registerationLimPan2UploadedFile=this.profileDetail.kyc_doc_7; 
         this.registerationLimAddressProofUploadedFile=this.profileDetail.kyc_doc_8;
         this.registerationLimAuthorityUploadedFile=this.profileDetail.kyc_doc_9; 
         }
         if(this.profileDetail.trade_entity=="5" || this.profileDetail.trade_entity==5)
         {
         this.kycDetailFromGroup.get('registerationPriName').setValue(this.profileDetail.field1);
         this.kycDetailFromGroup.get('registerationPriPartnerName').setValue(this.profileDetail.field2);
         this.kycDetailFromGroup.get('registerationPriPhoneNo').setValue(this.profileDetail.field3);  
         this.kycDetailFromGroup.get('registerationPriAlternateNo').setValue(this.profileDetail.field4);
         this.kycDetailFromGroup.get('registerationPriRocNo').setValue(this.profileDetail.field5);
         this.kycDetailFromGroup.get('registerationPriRocDate').setValue(this.profileDetail.field6);
         this.kycDetailFromGroup.get('registerationPriPanNo').setValue(this.profileDetail.field7);
         this.kycDetailFromGroup.get('registerationPriGstNo').setValue(this.profileDetail.field8);
         this.registerationPriPanUploadedFile=this.profileDetail.kyc_doc_1;
         this.registerationPriGstUploadedFile=this.profileDetail.kyc_doc_2;
         this.registerationPriCertificateUploadedFile=this.profileDetail.kyc_doc_3;
         this.registerationPriBusinessProofUploadedFile=this.profileDetail.kyc_doc_4;
         this.registerationPriArticlesUploadedFile=this.profileDetail.kyc_doc_5;
         this.registerationPriPhotoUploadedFile=this.profileDetail.kyc_doc_6;
         this.registerationPripan2UploadedFile=this.profileDetail.kyc_doc_7;
         this.registerationPriAddressProofUploadedFile=this.profileDetail.kyc_doc_8;
         this.registerationPriResolutionUploadedFile=this.profileDetail.kyc_doc_9;
         }

         this.creditCardFormGroup.get('creditCardName').setValue(this.profileDetail.credit_card_holder_name);
         this.creditCardFormGroup.get('creditCardNo').setValue(this.profileDetail.credit_card_number);
         this.creditCardFormGroup.get('creditCardMonth').setValue(this.profileDetail.credit_card_month);
         this.creditCardFormGroup.get('creditCardYear').setValue(this.profileDetail.credit_card_year);

         this.debitCardFormGroup.get('debitCardName').setValue(this.profileDetail.debit_holder_name);
         this.debitCardFormGroup.get('debitCardNo').setValue(this.profileDetail.debit_card_number);
         this.debitCardFormGroup.get('debitCardMonth').setValue(this.profileDetail.debit_card_month);
         this.debitCardFormGroup.get('debitCardYear').setValue(this.profileDetail.debit_card_year); 
 
         this.bankDetailFormGroup.get('bankName').setValue(this.profileDetail.bank_name);
         this.bankDetailFormGroup.get('bankIfscCode').setValue(this.profileDetail.ifsc_code);
         this.bankDetailFormGroup.get('bankAddress').setValue(this.profileDetail.bank_address);
         this.bankDetailFormGroup.get('bankAccountNo').setValue(this.profileDetail.bank_account_number);

         this.onChangeState(this.profileDetail.state_id);
         this.addressDetailFormGroup.get('addressDetail').setValue(this.profileDetail.address);
         this.addressDetailFormGroup.get('addressState').setValue(this.profileDetail.state_id);
         this.addressDetailFormGroup.get('addressCity').setValue(this.profileDetail.city_id);
         this.addressDetailFormGroup.get('addressPincode').setValue(this.profileDetail.pin_code);

       }
       }
     }
     else
     {
     show_okshan_alert(response.reason);
     this.isRequestInprocess=false;    
     } 
  }

   registerationIndPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndPanFile= file;
      //});
    }
    else{
       this.registerationIndPanFile="";
    }
  }
  registerationIndAadhaarFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndAadhaarFile= file;
      //});
    }
    else{
       this.registerationIndAadhaarFile="";
    }
  }
  registerationIndPassportFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndPassportFile= file;
      //});
    }
    else{
       this.registerationIndPassportFile="";
    }
  }
  registerationIndDLFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndDLFile= file;
      //});
    }
    else{
       this.registerationIndDLFile="";
    }
  }
  registerationIndVoterFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndVoterFile= file;
      //});
    }
    else{
       this.registerationIndVoterFile="";
    }
  }
  registerationIndPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndPhotoFile= file;
      //});
    }
    else{
       this.registerationIndPhotoFile="";
    }
  }
  registerationIndBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndBusinessProofFile= file;
      //});
    }
    else{
       this.registerationIndBusinessProofFile="";
    }
  }
registerationProPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProPanFile= file;
      //});
    }
    else{
       this.registerationProPanFile="";
    }
  }
  registerationProAadhaarFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProAadhaarFile= file;
      //});
    }
    else{
       this.registerationProAadhaarFile="";
    }
  }
  registerationProPassportFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProPassportFile= file;
      //});
    }
    else{
       this.registerationProPassportFile="";
    }
  }
  registerationProDLFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProDLFile= file;
      //});
    }
    else{
       this.registerationProDLFile="";
    }
  }
  registerationProVoterFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProVoterFile= file;
      //});
    }
    else{
       this.registerationProVoterFile="";
    }
  }
  registerationProPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProPhotoFile= file;
      //});
    }
    else{
       this.registerationProPhotoFile="";
    }
  }
  registerationProBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProBusinessProofFile= file;
      //});
    }
    else{
       this.registerationProBusinessProofFile="";
    }
  }
registerationParPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPanFile= file;
      //});
    }
    else{
       this.registerationParPanFile="";
    }
  }
  registerationParGstFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParGstFile= file;
      //});
    }
    else{
       this.registerationParGstFile="";
    }
  }
  registerationParBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParBusinessProofFile= file;
      //});
    }
    else{
       this.registerationParBusinessProofFile="";
    }
  }
  registerationParPartnershipProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPartnershipProofFile= file;
      //});
    }
    else{
       this.registerationParPartnershipProofFile="";
    }
  }
  registerationParPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPhotoFile= file;
      //});
    }
    else{
       this.registerationParPhotoFile="";
    }
  }
  registerationParPan2FileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPan2File= file;
      //});
    }
    else{
       this.registerationParPan2File="";
    }
  }
  registerationParAddressProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParAddressProofFile= file;
      //});
    }
    else{
       this.registerationParAddressProofFile="";
    }
  }
  registerationParAuthorityLetterFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParAuthorityLetterFile= file;
      //});
    }
    else{
       this.registerationParAuthorityLetterFile="";
    }
  }
registerationLimPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPanFile= file;
      //});
    }
    else{
       this.registerationLimPanFile="";
    }
  }
  registerationLimGstFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimGstFile= file;
      //});
    }
    else{
       this.registerationLimGstFile="";
    }
  }
  registerationLimCertificateFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimCertificateFile= file;
      //});
    }
    else{
       this.registerationLimCertificateFile="";
    }
  }
  registerationLimBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimBusinessProofFile= file;
      //});
    }
    else{
       this.registerationLimBusinessProofFile="";
    }
  }
  registerationLimPartnershipProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPartnershipProofFile= file;
      //});
    }
    else{
       this.registerationLimPartnershipProofFile="";
    }
  }
  registerationLimPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPhotoFile= file;
      //});
    }
    else{
       this.registerationLimPhotoFile="";
    }
  }
  registerationLimPan2FileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPan2File= file;
      //});
    }
    else{
       this.registerationLimPan2File="";
    }
  }
  registerationLimAddressProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimAddressProofFile= file;
      //});
    }
    else{
       this.registerationLimAddressProofFile="";
    }
  }
  registerationLimAuthorityFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimAuthorityFile= file;
      //});
    }
    else{
       this.registerationLimAuthorityFile="";
    }
  }

registerationPriPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriPanFile= file;
      //});
    }
    else{
       this.registerationPriPanFile="";
    }
  }
  registerationPriGstFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriGstFile= file;
      //});
    }
    else{
       this.registerationPriGstFile="";
    }
  }
  registerationPriCertificateFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriCertificateFile= file;
      //});
    }
    else{
       this.registerationPriCertificateFile="";
    }
  }
  registerationPriBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriBusinessProofFile= file;
      //});
    }
    else{
       this.registerationPriBusinessProofFile="";
    }
  }
  registerationPriArticlesFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriArticlesFile= file;
      //});
    }
    else{
       this.registerationPriArticlesFile="";
    }
  }
  registerationPriPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriPhotoFile= file;
      //});
    }
    else{
       this.registerationPriPhotoFile="";
    }
  }
  registerationPripan2FileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPripan2File= file;
      //});
    }
    else{
       this.registerationPripan2File="";
    }
  }
  registerationPriAddressProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriAddressProofFile= file;
      //});
    }
    else{
       this.registerationPriAddressProofFile="";
    }
  }
  registerationPriResolutionFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriResolutionFile= file;
      //});
    }
    else{
       this.registerationPriResolutionFile="";
    }
  }

  registerationCancelChequeFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationCancelChequeFile= file;
      //});
    }
    else{
       this.registerationCancelChequeFile="";
    }
  }

  /** editKycDoc function used to edit kyc doc */
  editKycDoc()
  {
    this.editKycDetailStatus=true;
  }

  /** cancelEditKycDoc function used to cancel edit kyc doc  */ 
  cancelEditKycDetail()
  {
    this.editKycDetailStatus=false;  
    this.kycDetailSaveBtnLabel="Save";  
  }

  /** proceedKycUpdate function used to proceed kyc update  */
  proceedKycUpdate(data)
  { 
    let validationError="";
    let formValidated=true;
    const formData = new FormData();
    /** if(data.registerationTradeEntity == "" || data.registerationTradeEntity == 0)
    {
     validationError=validationError+"Trade Entity Required";
      formValidated=false;
    } */
    
    if(data.registerationTradeEntity==1 || data.registerationTradeEntity=="1")
    {
    if(this.utilsService.trimming_fn(data.registerationIndName)=="")
    {
      validationError=validationError+"Enter individual name\n";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationIndPhoneNo)=="")
    {
      validationError=validationError+"Enter individual phone no.\n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationIndEmail)=="")
    {
      validationError=validationError+"Enter individual email\n";
      formValidated=false;
    }  
    formData.append('field1',data.registerationIndName);
    formData.append('field2',data.registerationIndPhoneNo);
    formData.append('field3',data.registerationIndAlternateNo);
    formData.append('field4',data.registerationIndEmail);
    formData.append('field5',data.registerationIndPan);
    formData.append('field6',data.registerationIndGstno);
    formData.append('field7','');
    formData.append('field8','');
    formData.append('kyc_doc_1',this.registerationIndPanFile);
    formData.append('kyc_doc_2',this.registerationIndAadhaarFile);
    formData.append('kyc_doc_3',this.registerationIndPassportFile);
    formData.append('kyc_doc_4',this.registerationIndDLFile);
    formData.append('kyc_doc_5',this.registerationIndVoterFile);
    formData.append('kyc_doc_6',this.registerationIndPhotoFile);
    formData.append('kyc_doc_7',this.registerationIndBusinessProofFile);
    formData.append('kyc_doc_8','');
    formData.append('kyc_doc_9','');
    }
    if(data.registerationTradeEntity==2 || data.registerationTradeEntity=="2")
    {
    if(this.utilsService.trimming_fn(data.registerationProTradeName)=="")
    {
      validationError=validationError+"Enter proprietorship trade name\n";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationProNo)=="")
    {
      validationError=validationError+"Enter proprietorship number\n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationProName)=="")
    {
      validationError=validationError+"Enter proprietorship name\n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationProEmail)=="")
    {
      validationError=validationError+"Enter proprietorship email\n";
      formValidated=false;
    }  
    formData.append('field1',data.registerationProTradeName);
    formData.append('field2',data.registerationProNo);
    formData.append('field3',data.registerationProName);
    formData.append('field4',data.registerationProPhoneNo);
    formData.append('field5',data.registerationProAlternateNo);
    formData.append('field6',data.registerationProEmail);
    formData.append('field7',data.registerationProPan);
    formData.append('field8',data.registerationProGstNo);
    formData.append('kyc_doc_1',this.registerationProPanFile);
    formData.append('kyc_doc_2',this.registerationProAadhaarFile);
    formData.append('kyc_doc_3',this.registerationProPassportFile);
    formData.append('kyc_doc_4',this.registerationProDLFile);
    formData.append('kyc_doc_5',this.registerationProVoterFile);
    formData.append('kyc_doc_6',this.registerationProPhotoFile);
    formData.append('kyc_doc_7',this.registerationProBusinessProofFile);
    formData.append('kyc_doc_8','');
    formData.append('kyc_doc_9','');
    }
    if(data.registerationTradeEntity==3 || data.registerationTradeEntity=="3")
    {
    if(this.utilsService.trimming_fn(data.registerationParName)=="")
    {
      validationError=validationError+"Enter partnership name\n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationParPartnerName)=="")
    {
      validationError=validationError+"Enter authorised partner name of partnership\n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationParPhoneNo)=="")
    {
      validationError=validationError+"Enter phone no of partnership\n";
      formValidated=false;
    }
    // if(this.utilsService.trimming_fn(data.registerationParEmail)=="")
    // {
    //   validationError=validationError+"Enter email of partnership\n";
    //   formValidated=false;
    // }      
    formData.append('field1',data.registerationParName);
    formData.append('field2',data.registerationParPartnerName);
    formData.append('field3',data.registerationParPhoneNo);
    formData.append('field4',data.registerationParAlternateNo);
    formData.append('field5',data.registerationParPan);
    formData.append('field6',data.registerationParEmail);
    formData.append('field7','');
    formData.append('field8','');
    formData.append('kyc_doc_1',this.registerationParPanFile);
    formData.append('kyc_doc_2',this.registerationParGstFile);
    formData.append('kyc_doc_3',this.registerationParBusinessProofFile);
    formData.append('kyc_doc_4',this.registerationParPartnershipProofFile);
    formData.append('kyc_doc_5',this.registerationParPhotoFile);
    formData.append('kyc_doc_6',this.registerationParPan2File);
    formData.append('kyc_doc_7',this.registerationParAddressProofFile);
    formData.append('kyc_doc_8',this.registerationParAuthorityLetterFile);
    formData.append('kyc_doc_9','');
    }
    if(data.registerationTradeEntity==4 || data.registerationTradeEntity=="4")
    {
    if(this.utilsService.trimming_fn(data.registerationLimName)=="")
    {
      validationError=validationError+"Enter limited liability partnership name\n";
      formValidated=false;
    }  
    if(this.utilsService.trimming_fn(data.registerationLimPartnerName)=="")
    {
      validationError=validationError+"Enter authorised partner name of limited liability partnership\n";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationLimPhoneNo)=="")
    {
      validationError=validationError+"Enter phone number of limited liability partnership\n";
      formValidated=false;
    } 
    formData.append('field1',data.registerationLimName);
    formData.append('field2',data.registerationLimPartnerName);
    formData.append('field3',data.registerationLimPhoneNo);
    formData.append('field4',data.registerationLimAlternateNo);
    formData.append('field5',data.registerationLimRocNo);
    formData.append('field6',data.registerationLimRocDate);
    formData.append('field7',data.registerationLimPan);
    formData.append('field8',data.registerationLimGstno);
    formData.append('kyc_doc_1',this.registerationLimPanFile);
    formData.append('kyc_doc_2',this.registerationLimGstFile);
    formData.append('kyc_doc_3',this.registerationLimCertificateFile);
    formData.append('kyc_doc_4',this.registerationLimBusinessProofFile);
    formData.append('kyc_doc_5',this.registerationLimPartnershipProofFile);
    formData.append('kyc_doc_6',this.registerationLimPhotoFile);
    formData.append('kyc_doc_7',this.registerationLimPan2File);
    formData.append('kyc_doc_8',this.registerationLimAddressProofFile);
    formData.append('kyc_doc_9',this.registerationLimAuthorityFile);
    }
    if(data.registerationTradeEntity==5 || data.registerationTradeEntity=="5")
    {
    if(this.utilsService.trimming_fn(data.registerationPriName)=="")
    {
      validationError=validationError+"Enter private limited company trade name \n";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationPriPartnerName)=="")
    {
      validationError=validationError+"Enter authorised partner name of private limited company \n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationPriPhoneNo)=="")
    {
      validationError=validationError+"Enter phone number of private limited company \n";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationPriPhoneNo)=="")
    {
      validationError=validationError+"Enter phone number of private limited company \n";
      formValidated=false;
    }   
    formData.append('field1',data.registerationPriName);
    formData.append('field2',data.registerationPriPartnerName);
    formData.append('field3',data.registerationPriPhoneNo);
    formData.append('field4',data.registerationPriAlternateNo);
    formData.append('field5',data.registerationPriRocNo);
    formData.append('field6',data.registerationPriRocDate);
    formData.append('field7',data.registerationPriPanNo);
    formData.append('field8',data.registerationPriGstNo);
    formData.append('kyc_doc_1',this.registerationPriPanFile);
    formData.append('kyc_doc_2',this.registerationPriGstFile);
    formData.append('kyc_doc_3',this.registerationPriCertificateFile);
    formData.append('kyc_doc_4',this.registerationPriBusinessProofFile);
    formData.append('kyc_doc_5',this.registerationPriArticlesFile);
    formData.append('kyc_doc_6',this.registerationPriPhotoFile);
    formData.append('kyc_doc_7',this.registerationPripan2File);
    formData.append('kyc_doc_8',this.registerationPriAddressProofFile);
    formData.append('kyc_doc_9',this.registerationPriResolutionFile);
    }
    formData.append('trade_entity',this.profileDetail.trade_entity);
    

    if(formValidated==false)
    {
      show_okshan_alert(validationError);
      return false;
    }    
    this.isRequestInprocess=true;
    this.kycDetailSaveBtnLabel="Saving..."; 
    formData.append('profile_id',this.sessionsService.getSession("id"));
    let result =this.httpserviceService.kycDetailUpdateRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.kycDetailUpdateResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.kycDetailSaveBtnLabel="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })    
  }

  /** kycDetailUpdateResponse function used to handle response */
  kycDetailUpdateResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {   
     this.cancelEditKycDetail();  
     this.isRequestInprocess=false;  
     this.proceedGetProfileDetail();
     }
     else
     {
     show_okshan_alert(response.reason);
     this.isRequestInprocess=false;  
     this.kycDetailSaveBtnLabel="Save";  
     } 
  } 

  /** proceedChangePassword function used to proceed change password */
  proceedChangePassword(data)
  {
    this.isPasswordSubmitted=true;
    if(data.newPassword!=data.confirmPassword)
    {
      this.changePasswordMsg="New password and confirm password must be same";
      return false;
    }
    if(this.changePasswordFormGroup.valid)
    {
      this.isRequestInprocess=true;
    this.chnagePasswordBtnLbl="Saving..."; 
    let body={profile_id: this.sessionsService.getSession('id'),otp:data.oldPassword,mobile_number:"+91"+this.profileDetail.mobile_no,password:btoa(data.newPassword)}
    let result =this.httpserviceService.changePasswordWithMobileOtpRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.changePasswordResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.chnagePasswordBtnLbl="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
    }
  }

  /** changePasswordResponse function used to handle response */
  changePasswordResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.isPasswordSubmitted=false;   
     this.changePasswordMsg="Password changed successfully";   
     this.changePasswordFormGroup.reset();  
     this.isRequestInprocess=false;  
     this.chnagePasswordBtnLbl="Save";   
     setTimeout(() => {
     this.changePasswordMsg="";  
     }, 4000);  
     }
     else
     {
     this.changePasswordMsg=response.reason;
     this.isRequestInprocess=false;  
     this.chnagePasswordBtnLbl="Save"; 
     setTimeout(() => {
     this.changePasswordMsg="";  
     }, 4000);
     } 
  }

  /** proceedCreditCardRequest function used to save credit card detail */ 
  proceedCreditCardRequest(data)
  {
    this.isCreditCardSubmited=true;
    if(this.creditCardFormGroup.valid)
    {
      this.isRequestInprocess=true;
    this.creditCardBtnLbl="Saving..."; 
    let result =this.httpserviceService.creditCardRequest(data.creditCardName,data.creditCardNo,data.creditCardMonth,data.creditCardYear).
     pipe(retry(0)).
     subscribe((data)=>this.creditCardResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.creditCardBtnLbl="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
    }
  }

  /** creditCardResponse function used to handle response */
  creditCardResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.isCreditCardSubmited=false;   
     this.creditCardMsg="Credit Card detail saved successfully";   
     this.isRequestInprocess=false;  
     this.creditCardBtnLbl="Save";   
     setTimeout(() => {
     this.creditCardMsg="";  
     }, 4000);  
     }
     else
     {
     this.creditCardMsg=response.reason;
     this.isRequestInprocess=false;  
     this.creditCardBtnLbl="Save"; 
     setTimeout(() => {
     this.creditCardMsg="";  
     }, 4000);
     } 
  }


/** proceedDebitCardRequest function used to save debit card detail */ 
  proceedDebitCardRequest(data)
  {     
    this.isDebitCardSubmited=true;
    if(this.debitCardFormGroup.valid)
    { 
      this.isRequestInprocess=true;
    this.debitCardBtnLbl="Saving..."; 
    let result =this.httpserviceService.debitCardRequest(data.debitCardName,data.debitCardNo,data.debitCardMonth,data.debitCardYear).
     pipe(retry(0)).
     subscribe((data)=>this.debitCardResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.debitCardBtnLbl="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
    }
  }  

  /** debitCardResponse function used to handle response */
  debitCardResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.isDebitCardSubmited=false;   
     this.debitCardMsg="Debit Card detail saved successfully";   
     this.isRequestInprocess=false;  
     this.debitCardBtnLbl="Save";   
     setTimeout(() => {
     this.debitCardMsg="";  
     }, 4000);  
     }
     else
     {
     this.debitCardMsg=response.reason;
     this.isRequestInprocess=false;  
     this.debitCardBtnLbl="Save"; 
     setTimeout(() => {
     this.debitCardMsg="";  
     }, 4000);
     } 
  }

  /** selectCancelledCheque function used to select cancelled cheque */
  selectCancelledCheque(event) {    
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.cancelledChequeFile= file;
      //});
    }
    else{
       this.cancelledChequeFile="";
    }
  }

  /** proceedBankDetailSave function used to save bank detail */ 
  proceedBankDetailSave(data)
  {     
    this.isBankDetailSubmited=true;
    if(this.bankDetailFormGroup.valid)
    { 
      let formData=new FormData();
      formData.append('profile_id',this.sessionsService.getSession("id"));
      formData.append("bank_name",data.bankName);
      formData.append("ifsc_code",data.bankIfscCode);
      formData.append("bank_address",data.bankAddress);
      formData.append("bank_account_number",data.bankAccountNo);
      formData.append("cancelled_cheque",this.cancelledChequeFile);
      this.isRequestInprocess=true;
    this.bankDetailBtnLbl="Saving..."; 
    let result =this.httpserviceService.bankDetailSaveRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.bankDetailSaveResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.bankDetailBtnLbl="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
    }
  }

  /** debitCardResponse function used to handle response */
  bankDetailSaveResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.isBankDetailSubmited=false;   
     this.bankDetailMsg="Debit Card detail saved successfully";   
     this.isRequestInprocess=false;  
     this.bankDetailBtnLbl="Save";   
     setTimeout(() => {
     this.bankDetailMsg="";  
     }, 4000);  
     }
     else
     {
     this.bankDetailMsg=response.reason;
     this.isRequestInprocess=false;  
     this.bankDetailBtnLbl="Save"; 
     setTimeout(() => {
     this.bankDetailMsg="";  
     }, 4000);
     } 
  }

  /** proceedAddressSave function used to save address detail */ 
  proceedAddressSave(data)
  {     
    this.isaAddressDetailSubmited=true;
    if(this.addressDetailFormGroup.valid)
    { 
      this.isRequestInprocess=true;
    this.addressDetailBtnLbl="Saving..."; 
    let result =this.httpserviceService.addressUpdateRequest(data.addressDetail,data.addressState,data.addressCity,data.addressPincode).
     pipe(retry(0)).
     subscribe((data)=>this.addressSaveResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.addressDetailBtnLbl="Save";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
    }
  }  

  /** addressSaveResponse function used to handle response */
  addressSaveResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.isaAddressDetailSubmited=false;   
     this.addressDetailMsg="Address saved successfully";   
     this.isRequestInprocess=false;       
     this.addressDetailBtnLbl="Save";   
     setTimeout(() => {
     this.addressDetailMsg="";  
     }, 4000);  
     //this.addressDetailFormGroup.reset();
     //this.getAddressList();
     }
     else
     {
     this.addressDetailMsg=response.reason;
     this.isRequestInprocess=false;  
     this.addressDetailBtnLbl="Save"; 
     setTimeout(() => {
     this.addressDetailMsg="";  
     }, 4000);
     } 
  }

  /** getAddressList function used to get address list */ 
  getAddressList()
  { 
    let result =this.httpserviceService.getAddressListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAddressListResponse(data),
     err => {
       this.isRequestInprocess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getAddressListResponse function used to handle response */
  getAddressListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.addressList=response.list;
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** proceedRemoveAddress function used to proceed remove address */
  proceedRemoveAddress(id)
  {
    if(confirm("Are you sure want to remove ?"))
    {
    let result =this.httpserviceService.removeAddressRequest(id).
     pipe(retry(0)).
     subscribe((data)=>this.removeAddressResponse(data),
     err => {
       this.isRequestInprocess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
    }
  }

  /** removeAddressResponse function used to handle response */
  removeAddressResponse(response)
  {    
    console.log('removeAddressResponse '+ response.status);
    if(response.status==="success")  
     { 
     this.getAddressList();
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }  
  
  /** getStateNameFromId function used to get state name from state id */
  getStateNameFromId(id)
  {
    return this.allStateList[id];       
  }  

  /** getCityNameFromId function used to get city name from city id */
  getCityNameFromId(id)
  {
    return this.allcityList[id];       
  }

  /** getStateFromId function used to get state from id  */
   getStateFromId(id)
   {
     if(this.sessionsService.getSession('all_state')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_state');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   } 

   /** getCityFromId function used to get city from id  */
   getCityFromId(id)
   {
     if(this.sessionsService.getSession('all_city')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_city');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   } 

   /** onChangeState function used to perform event on state change */
  onChangeState(value)
  {
   let list=this.sessionsService.getSession("state_city_list"); 
   this.cityList=list[value];
  }

  /** proceedKycStatusRequest function used to proceed kyc status request */
  proceedKycStatusRequest()
  {
    let body={profile_id: this.sessionsService.getSession('id')}
    let result =this.httpserviceService.getKycStatusRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.getKycStatusResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** getKycStatusResponse function used to get kyc status response */
  getKycStatusResponse(response)
  {    
    console.log('getKycStatusResponse '+ response.status);
    if(response.status==="success")  
     { 
       if(response.kyc_bit)
       {         
         if(response.kyc_bit[0])
         {         
            let status=response.kyc_bit[0].status;
            this.kycBit=status;
            if(status===0)
            {
              this.kycStatus="Complete KYC"
            }
            else if(status===1)
            {
              this.kycStatus="KYC Approval Pending"
            }
            else if(status===2)
            {
              this.kycStatus="KYC Approved"
            }
         }
       }
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** ProceedSendChangePasswordOtp function used to proceed send change password otp */
 ProceedSendChangePasswordOtp()
  {
    this.chnagePasswordSendOtpBtnLbl="Sending...";
    let body={profile_id: this.sessionsService.getSession('id'),type:"change password",mobile_number:"+91"+this.profileDetail.mobile_no}
    let result =this.httpserviceService.sendChangePasswordOtpRequest2(body).
     pipe(retry(0)).
     subscribe((data)=>this.sendChangePasswordOtpResponse(data),
     err => {
       this.chnagePasswordSendOtpBtnLbl="Send";
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** sendChangePasswordOtpResponse function used to send change password otp response */
  sendChangePasswordOtpResponse(response)
  {    
    console.log('getKycStatusResponse '+ response.status);
    if(response.status==="success")  
     {       
       this.chnagePasswordSendOtpBtnLbl="Resend";
     }
     else
     {
     this.chnagePasswordSendOtpBtnLbl="Send";  
     show_okshan_alert(response.reason);     
     } 
  }

  
}
